import React, { useState } from 'react'
import UploadFile from './uploadFile'
import { Button, ButtonGroup, Backdrop, CircularProgress } from '@material-ui/core'
import { Container, Row, Col } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { ZeoFiles } from './ZeoFiles'

const Planning = () => {
    const [state, setState] = useState({ Path: 'SeparadorSector', key: 1, titulo: 'Separador por Sector', tipo: '', client: '' })
    const { user: currentUser } = useSelector(state => state.auth)
    const [loading, setLoading] = useState(false)

    const menuContent = [
        {
            group: 'Manifiestos',
            user: [],
            items: [
                {
                    title: 'Manifiesto Paris',
                    path: 'ManifiestoParis'
                },
                {
                    title: 'Manifiesto Falabella',
                    path: 'ManifiestoFalabella'
                },
                {
                    title: 'Manifiesto Ripley Redex',
                    path: 'ManifiestoAutomatizado'
                },
                {
                    title: 'Manifiesto Ripley Sameday',
                    path: 'ManifiestoAutomatizado'
                },
                // {
                //     title: 'Manifiesto Nclientes',
                //     path: 'ManifiestoAutomatizado'
                // },
                {
                    title: 'Manifiesto Ripley',
                    path: 'ManifiestoAutomatizado',
                    client: 'Ripley'
                },
                {
                    title: 'Manifiesto Shipit',
                    path: 'ManifiestoAutomatizado',
                    client: 'Shipit'
                },
                {
                    title: 'Manifiesto Karri',
                    path: 'ManifiestoAutomatizado',
                    client: 'Karri'
                },
                {
                    title: 'Manifiesto Llego',
                    path: 'ManifiestoAutomatizado',
                    client: 'Llego'
                },
                {
                    title: 'Manifiesto Walmart',
                    path: 'ManifiestoAutomatizado',
                    client: 'Walmart'
                },
                {
                    title: 'Manifiesto Dimeiggs',
                    path: 'ManifiestoAutomatizado',
                    client: 'Dimeiggs'
                }
            ]
        },
        {
            group: 'Test',
            user: ['eduardo@spread.cl'],
            items: [
                {
                    title: 'Planificación 2.0',
                    path: 'planificacion2'
                }
            ]
        },
        {
            group: 'Planificación ZEO',
            user: ['eduardo@spread.cl', 'heiner.zuniga@spread.cl', 'planner@spread.cl', 'opl@spread.cl', 'operaciones@spread.cl','dianela.arrieta@spread.cl','mariano@spread.cl'],
            items: [
                {
                    title: 'Generar archivos ZEO',
                    path: 'generacionZeo',
                    tipo: 'ZEO'
                },
                {
                    title: 'Subir archivos ZEO',
                    path: 'generarLastMile',
                    tipo: 'ZEO'
                },
            ]
        }
    ]

    return (
        <Container fluid className='g-0 w-100'>
            <Backdrop
                sx={{ color: '#fff' }}
                style={{ zIndex: 999 }}
                open={loading}
            >
                <CircularProgress />
            </Backdrop>
            <Row className='pt-5 gx-0 text-center'>
                <h3>{state.titulo}</h3>
            </Row>
            <Row className='text-center gx-0' style={{ height: 'calc(100vh - 200px' }}>
                <Col xs={2} className='text-center align-self-center spread-font' style={{ margin: "10px" }}>
                    {/* <ButtonGroup
                        orientation="vertical"
                        aria-label="vertical contained primary button group"
                        className='mx-2'
                    > */}
                    <>
                        {
                            menuContent.map((group, index) => {
                                if (group.user.length === 0) {
                                    return (
                                        <div key={index}>
                                            <h6>{group.group}</h6>
                                            {
                                                group.items.map((item, index) => {
                                                    return (
                                                        <Button
                                                            key={index}
                                                            color="primary"
                                                            variant="contained"
                                                            style={{ backgroundColor: 'rgb(0, 155, 120)', marginBottom: 5, width: '100%' }}
                                                            onClick={() => {
                                                                setState({ Path: item.path, key: state.key + 1, titulo: item.title, tipo: item.tipo, client: item.client })
                                                            }}
                                                        >
                                                            {item.title}
                                                        </Button>
                                                    )
                                                })
                                            }
                                        </div>
                                    )
                                } else {
                                    if (group.user.includes(currentUser.email)) {
                                        return (
                                            <div key={index}>
                                                <hr />
                                                <h6>{group.group}</h6>
                                                {
                                                    group.items.map((item, index) => {
                                                        return (
                                                            <Button
                                                                key={index}
                                                                color="primary"
                                                                variant="contained"
                                                                style={{ backgroundColor: '#A5FF4B', color: '#000', marginBottom: 5, width: '100%' }}
                                                                onClick={() => {
                                                                    setState({ Path: item.path, key: state.key + 1, titulo: item.title, tipo: item.tipo, client: item.client })
                                                                }}
                                                            >
                                                                {item.title}
                                                            </Button>
                                                        )
                                                    })
                                                }
                                            </div>
                                        )
                                    }
                                }
                            })
                        }
                    </>
                    {/* </ButtonGroup> */}
                </Col>
                {
                    state.tipo === 'ZEO'
                        ? <ZeoFiles path={state.Path} title={state.titulo} loading={loading} setLoading={setLoading} />
                        : <UploadFile path={state.Path} titulo={state.titulo} client={state.client} loading={loading} setLoading={setLoading} />
                }
                {/* <Col xs={2}></Col> */}
            </Row>
        </Container>
    )
}

export default Planning
